var _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCriticalErrorIcon = function SvgCriticalErrorIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5406_8)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5406_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#69DAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5406_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5406_8)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6347 14.5242L55.8432 9.31575L53.879 7.35156L46.5874 14.6431L52.6486 20.0309L46.4053 24.5715L48.0391 26.818L57.0735 20.2475L50.6347 14.5242Z",
    fill: "#1C9E97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 24.8269C16.6666 23.3875 17.83 22.2207 19.2652 22.2207H54.3458C55.781 22.2207 56.9444 23.3875 56.9444 24.8269V57.1145C56.9444 58.5539 55.781 59.7207 54.3458 59.7207H19.2652C17.83 59.7207 16.6666 58.5539 16.6666 57.1145V24.8269Z",
    fill: "#E2E2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2222 24.8269C22.2222 23.3875 23.3857 22.2207 24.8211 22.2207H80.7344C82.1697 22.2207 83.3333 23.3875 83.3333 24.8269V57.1145C83.3333 58.5539 82.1697 59.7207 80.7344 59.7207H24.8211C23.3857 59.7207 22.2222 58.5539 22.2222 57.1145V24.8269Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3888 26.3887H79.1666V55.5553H26.3888V26.3887Z",
    fill: "#1FCBC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2777 55.5558C40.2777 51.7205 43.3868 48.6113 47.2222 48.6113H58.3333C62.1686 48.6113 65.2777 51.7205 65.2777 55.5558V55.5558H40.2777V55.5558Z",
    fill: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5406_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 34,
    width: 10,
    height: 10
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2934 43.274C45.7196 43.274 47.698 41.2979 47.698 38.8757C47.698 36.4528 45.7196 34.4766 43.2934 34.4766C40.8676 34.4766 38.8888 36.4528 38.8888 38.8757C38.8888 41.2979 40.8676 43.274 43.2934 43.274",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5406_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2934 43.274C45.7196 43.274 47.698 41.2979 47.698 38.8757C47.698 36.4528 45.7196 34.4766 43.2934 34.4766C40.8676 34.4766 38.8888 36.4528 38.8888 38.8757C38.8888 41.2979 40.8676 43.274 43.2934 43.274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8086 39.1309L51.026 36.9569V29.3483H35.8086V39.1309Z",
    fill: "#E2E2E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5406_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 34,
    width: 10,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7379 43.274C65.1641 43.274 67.1425 41.2979 67.1425 38.8757C67.1425 36.4528 65.1641 34.4766 62.7379 34.4766C60.3121 34.4766 58.3333 36.4528 58.3333 38.8757C58.3333 41.2979 60.3121 43.274 62.7379 43.274",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5406_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7379 43.274C65.1641 43.274 67.1425 41.2979 67.1425 38.8757C67.1425 36.4528 65.1641 34.4766 62.7379 34.4766C60.3121 34.4766 58.3333 36.4528 58.3333 38.8757C58.3333 41.2979 60.3121 43.274 62.7379 43.274",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6418 39.1309L71.8592 36.9569V29.3483H56.6418V39.1309Z",
    fill: "#E2E2E2"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.861 11.1105C56.7736 11.1105 58.3332 9.55052 58.3332 7.63857C58.3332 5.72596 56.7736 4.16602 54.861 4.16602C52.9487 4.16602 51.3888 5.72596 51.3888 7.63857C51.3888 9.55052 52.9487 11.1105 54.861 11.1105",
    fill: "#1C9E97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8334 59.7227H59.7223V80.556H45.8334V59.7227Z",
    fill: "#E2E2E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7223 59.7227H45.8334V68.056L59.7223 62.5004V59.7227Z",
    fill: "#ACACAC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6111 72.9985C23.6111 71.8031 24.572 70.834 25.7573 70.834H77.122C77.8774 70.834 78.5771 71.2344 78.9645 71.8884L101.082 109.226C101.936 110.669 100.906 112.501 99.2393 112.501H25.7573C24.572 112.501 23.6111 111.532 23.6111 110.336V72.9985Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3889 72.9985C26.3889 71.8031 25.4055 70.834 24.1923 70.834H17.892C17.1189 70.834 16.4027 71.2344 16.0062 71.8884L-6.63016 109.226C-7.50486 110.669 -6.44997 112.501 -4.74444 112.501H24.1923C25.4055 112.501 26.3889 111.532 26.3889 110.336V72.9985Z",
    fill: "#E2E2E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8889 79.166H77.0532L89.0097 99.8182H50.8454L38.8889 79.166Z",
    fill: "#E2E2E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7542 72.9985C20.7542 71.8031 21.7241 70.834 22.9204 70.834H25.5076C26.27 70.834 26.9762 71.2344 27.3672 71.8884L49.6901 109.226C50.5526 110.669 49.5124 112.501 47.8305 112.501H0.777261C-0.419085 112.501 -1.38892 111.532 -1.38892 110.336L20.7542 72.9985Z",
    fill: "#E2E2E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2781 78.3664C42.6096 74.3281 47.0933 72.3071 51.4439 72.9156L46.2921 81.8386L53.509 86.0053L58.6607 77.0822C61.363 80.5457 61.8546 85.4392 59.5231 89.4775C57.1916 93.5158 52.7079 95.5369 48.3574 94.9284L28.509 129.307L21.2921 125.14L41.1405 90.7617C38.4381 87.2983 37.9466 82.4047 40.2781 78.3664Z",
    fill: "#1FCBC2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5406_8",
    x: 0,
    y: -3,
    width: 100,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5406_8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5406_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCriticalErrorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "critical-error-icon.9bdd3c1659ab96c4981d52f747fcd182.svg";